export const subscription = {
  titles: {
    subscription: "Abonnement",
    freeTrial: "Kostenlose Testphase",
    expired: "Abgelaufen",
  },

  status: {
    active: "Aktiv",
    canceled: "Gekündigt",
    trialAccess: "KOSTENLOSE TESTPHASE",
    expiredAccess: "ZUGANG ABGELAUFEN",
  },

  notices: {
    activeDesc: "Verwalten Sie die Details Ihres Abonnements und Ihre Upgrade-Optionen.",
    canceledDesc:
      "Ihr Abonnement wurde gekündigt. Sie behalten den Zugang bis zum Enddatum.",
    trialDesc: "Sie haben bis zum Ablaufdatum Zugriff auf die Funktionen des Systems.",
    expiredDesc:
      "Ihre Testphase ist beendet. Abonnieren Sie, um den Dienst weiter zu nutzen.",
    upgradeHint:
      "Verlieren Sie nicht den Zugang zu den erweiterten Funktionen, erweitern Sie Ihr Abonnement jetzt",
    expiredHint:
      "Ihr Zugang ist abgelaufen. Abonnieren Sie, um alle Funktionen weiter zu nutzen",
    needFullAccess: "Brauchen Sie vollen Zugriff?",
    choosePlan: "Wählen Sie den Plan, der zu Ihnen passt",
  },

  labels: {
    planActive: "Aktiver Plan",
    stateNow: "Aktueller Status",
    trialPeriod: "Testphase",
    periodExpired: "Abgelaufener Zeitraum",
    summary: "Übersicht des Abonnements",
    timeLeft: "Verbleibende Zeit",
    trialExpiresIn: "Ihre kostenlose Testphase endet in {days} Tagen",
    expirationDate: "Ablaufdatum",
    nextRenewal: "Nächste Verlängerung",
    accessUntil: "Zugang verfügbar bis",
    perUnit: "/ Pro {unit}",
    unitRoom: "Zimmer",
    unitRoomMultiple: "Mehrere Zimmer",
    unitApartment: "Apartment",
    unitVilla: "Villa",
    unitCamping: "Camping",
    unitLodging: "Unterkunft",
    annualPlan: "Jahresplan",
    monthlyPlan: "Monatsplan",
  },

  actions: {
    addUnit: "{unitLabel} hinzufügen",
    manageSubAndPayment: "Abonnement und Zahlungsart verwalten",
    processing: "Wird verarbeitet...",
    subscribeNow: "Jetzt abonnieren",
    chooseAPlan: "Plan wählen",
    goToSubscriptionPage: "Zu den Plänen",
  },

  confirmCancel: {
    title: "Abonnement kündigen?",
    text: "Wenn Sie kündigen, verlieren Sie den Zugang zu Ihren Diensten.",
    confirm: "Ja, kündigen",
    cancel: "Nein",
  },

  formats: {
    priceTotalHTML: "{price}",
    dateDDMMYYYY: "{date}",
  },

  modal: {
    title: 'Abonnement aktiviert!',
    details: "Details zum Abonnement",
    welcomeTitle: "Willkommen bei WA Checkin {plan}!",
    welcomeBody:
      "Sie haben jetzt vollen Zugriff auf unsere Check-in-Tools über WhatsApp, die OTA-Synchronisierung, den KI-Chatbot, Automatisierungen und vieles mehr.",
    feature1: {
      title: "Tarife und Verfügbarkeit verwalten",
      desc: "Bearbeiten Sie Ihre Preise mühelos und steuern Sie die Auslastung in Echtzeit, alles an einem Ort.",
    },
    feature2: {
      title: "Direktbuchungen erhalten",
      desc: "Über Ihre eigene Website können Gäste direkt buchen, ohne den Umweg über OTAs.",
    },
    schedule: {
      help: "Vereinbaren Sie einen kostenlosen Videoanruf und wir helfen Ihnen, alles einzurichten.",
      cta: "Videoanruf vereinbaren",
    },
  },

  sectionPlans: {
    title: "Liste der Pläne",
    confirm: {
      header: "Plan-Upgrade bestätigen",
      loadingMsg: "Ihr Plan wird aktualisiert, bitte warten.",
      body: "Sie sind dabei, den Plan Ihres Kontos auf {plan} zu ändern.",
    },
    actions: {
      cancel: "Abbrechen",
      confirmUpgrade: "Upgrade bestätigen",
      goToBilling: "Zu den Zahlungsarten",
      accept: "OK",
      updateSubscription: "Abonnement aktualisieren", // NEW
    },
    success: {
      title: "Geschafft",
      body: "Ihr Abonnement wurde aktualisiert.",
    },
    errors: {
      processTitle: "Fehler bei der Verarbeitung der Anfrage",
      unknownUpdate: "Unbekannter Fehler beim Aktualisieren des Abonnements.",
      genericTitle: "Fehler",
      genericBody: "Das Abonnement konnte nicht aktualisiert werden.",
    },
  },

  plans: {
    features: {
      installation: "Persönliches Onboarding mit einem Experten",
      fastSupport: "Schneller Support per E-Mail, Chat und Telefon",
      whatsappCheckin: "Check-in über WhatsApp",
      linkEmailCheckin: "Check-in über Link / E-Mail",
      welcomeMessage: "Willkommensnachricht per WhatsApp und E-Mail",
      digitalSignature: "Digitale Unterschrift der Hausordnung",
      idScanner: "Scanner für Ausweis und Reisepass",
      sesHospedajesSend: "Automatische Meldung an die Polizeibehörden",
      reviewLink: "Google-Bewertungslink nach dem Check-out senden",
      smartLocks: "Anbindung an Ihre smarten Schlösser",
      channelManager1: "Channel Manager (Anbindung an 1 OTA)",

      includesLite: "Alles aus Lite",
      selfieVerification: "Gastprüfung beim Check-in per Selfie",
      unifiedInbox: "Gemeinsamer Posteingang",
      upsellServices: "Leistungen und Erlebnisse über WhatsApp anbieten",
      paymentLinks: "Zahlungen von Gästen (Zahlungslink für Karte)",
      websiteBookings: "Buchungswebsite mit synchronisiertem Kalender",
      channelManagerUnified: "Channel Manager (Zusammengeführte Kalender, über 100 OTAs)",
      channelManagerCentralPrices:
        "Channel Manager (Zentrale Preisverwaltung)",
      guestSupportOption: "Option, Guest Support hinzuzubuchen",

      includesStandard: "Alles aus Standard",
      centralizedPriceManager: "Zentrale Preisverwaltung",
      aiChatbot: "KI-Chatbot für WhatsApp (FAQ und Automatisierung)",
      googleVacationRentals: "Integration mit Google Vacation Rentals",
      whatsappReminders: "WhatsApp-Erinnerungen für Gäste",
      eInvoicingSoon: "Elektronische Rechnung (demnächst)",
      prioritySupport: "Bevorzugter Support",
    },
  },

  planCard: {
    perSlash: "/pro", // separator "/per {unit}"
    infoTitle: "Details zum Plan",
    update: "Aktualisieren",
    subscribe: "Abonnieren",
    currentPlan: "Aktueller Plan",
    byApartment: "pro Apartment",
    byVilla: "pro Villa",
    byCamping: "pro Campingplatz",
    byRoom: "pro Zimmer",
    byUnit: "pro Einheit",
  },

  services: {
    title: "Zusätzliche Leistungen",
    ctaComingSoon: "Demnächst",
    guestSupport: {
      title: "Guest-Support-Service",
      subtitle: "Wir übernehmen WhatsApp und Telefonanrufe Ihrer Gäste für Sie.",
      desc: "Wir helfen ihnen beim Check-in, beantworten ihre Fragen und nehmen auch Anrufe zu Direktbuchungen entgegen. Sie bleiben entspannt, während Ihre Gäste ab dem ersten Kontakt ein Erlebnis mit 10 von 10 bekommen.",
    },
    chatbot: {
      title: "KI-ChatBot",
      activeService: "Dienst aktiv",
      desc: "Buchen Sie den KI-Chatbot dazu und beantworten Sie Anfragen Ihrer Gäste automatisch, schnell und effizient.",
      activateCta: "Dienst aktivieren",
      confirm: {
        header: "Aktivierung bestätigen",
        loadingMsg: "Der ChatBot-Dienst wird aktiviert, bitte warten.",
        body: "Sie sind dabei, den KI-ChatBot-Dienst für Ihre {units} Unterkünfte zu aktivieren.",
      },
      discount: {
        applied: "Angewendeter Rabatt:",
        couponFallback: "Gutschein",
      },
      pricing: {
        unitPrice: "Einzelpreis:",
        quantity: "Menge:",
        totalToPay: "Zu zahlen insgesamt:",
      },
    },
  },

  invoices: {
    title: "Rechnungen und Belege",
    created: "Erstellt",
    status: "Status",
    amount: "Betrag",
    paid: "Bezahlt",
    unpaid: "Offen",
    viewInvoice: "Rechnung ansehen",
    empty: "Sie haben noch keine Rechnungen.",
  },

  updateModal: {
    header: "{unitLabel} hinzufügen",
    body: "Fügen Sie Ihrem Abonnement die Anzahl der {unitLabelPlural} hinzu.",
    pricing: {
      discountApplied: "Auf das Abonnement angewendeter Rabatt:",
      unitPrice: "Einzelpreis:",
      quantity: "Menge:",
      totalNewUnits: "Summe für die neuen Einheiten:",
      newSubscriptionTotal: "Neuer Gesamtwert des Abonnements:",
    },
    prorationNote:
      "Änderungen am Abonnement werden anteilig nach den verbleibenden Tagen des laufenden Zeitraums berechnet. Der volle Betrag wird im nächsten Monat abgebucht.",
  },

  page: {
    findRightPlan: "Finden Sie den passenden Plan",
    enterAmount: "Anzahl eingeben",
    numberOf: "Anzahl der {unit}"
  },
  billing: {
    title: "Abrechnungszeitraum wählen",
    subtitle: "Wählen Sie, wie Sie zahlen möchten",
    monthly: "Monatlich",
    annual: "Jährlich",
    discountShort: "−{percent}%",
  },
};
